<template>
  <v-card>
    <v-card-title class="pb-8">
      <h3>Operazioni</h3>
      <v-spacer />
      <v-text-field
        v-model="searchFilter"
        append-icon="mdi-magnify"
        label="Cerca"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="items"
        single-expand
        show-expand
        :search="search"
        :items-per-page="100"
        :footer-props="{
					itemsPerPageAllText: 'Tutte',
					itemsPerPageOptions: [15, 50, 100, -1],
					itemsPerPageText: 'Operazioni per pagina',
				}"
      >
        <template v-slot:no-data>
          Nessuna operazione.
        </template>

        <template v-slot:item.posix="{ item }">
          <span>{{ posixToItalianDate(item.posix) }}</span>
        </template>

        <template v-slot:item.price="{ item }">
          <span>{{ item.price }}€</span>
        </template>

        <template v-slot:item.vat="{ item }">
          <span v-if="item.vat == 0">
            <span>{{ item.vat }}€</span>
          </span>
          <span v-else>
            <span class="red--text">{{ item.vat }}€</span>
          </span>
        </template>

        <template v-slot:item.gain="{ item }">
          <span v-if="item.gain >= 0">
            <span>{{ item.gain }}€</span>
          </span>
          <span v-else>
            <span class="red--text">{{ item.gain }}€</span>
          </span>
        </template>

        <template v-slot:item.coffee="{ item }">
          <span v-if="item.coffee === 1">
            <v-icon color="green">mdi-check</v-icon>
          </span>
          <span v-else>
            <v-icon color="red">mdi-close</v-icon>
          </span>
        </template>

        <template v-slot:item.gift="{ item }">
          <span v-if="item.gift === 1">
            <v-icon color="green">mdi-check</v-icon>
          </span>
          <span v-else>
            <v-icon color="red">mdi-close</v-icon>
          </span>
        </template>

        <template v-slot:item.points_sh="{ item }">
          <span v-if="item.points_sh === 1">
            <v-icon color="green">mdi-check</v-icon>
          </span>
          <span v-else>
            <v-icon color="red">mdi-close</v-icon>
          </span>
        </template>

        <template v-slot:item.b2b="{ item }">
          <span v-if="item.b2b === 1">
            <v-icon color="green">mdi-check</v-icon>
          </span>
          <span v-else>
            <v-icon color="red">mdi-close</v-icon>
          </span>
        </template>

        <template v-slot:item.invoice="{ item }">
          <span v-if="item.invoice === 1">
            <v-icon color="green">mdi-check</v-icon>
          </span>
          <span v-else>
            <v-icon color="red">mdi-close</v-icon>
          </span>
        </template>

        <template v-slot:expanded-item="{ item }">
          <article-details
            :article="item"
            v-on:fetch="emitFetch"
          />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import ArticleDetails from './../registro/ArticleDetails'

  export default {
    name: 'Table',

    components: {
      ArticleDetails,
    },

    props: {
      operations: { kind: Array, default: () => [] },
    },

    data() {
      return {
        search: '',
        options: {
          keys: [
            'article.name',
            'article.serial_code',
            'article.serial_number',
            'article.ean',
            'article.brand',
            'article.model',
            'article.color',
            'article.desctiption',
            'article.grade',
            'disk_space',
            'ram',
            'operator_from',
            'operator_to',
            'offer_name',
            'offer_payment',
            'contract_kind',
            'name',
            'surename',
            'phone',
            'email',
            'fiscal_code',
            'user',
            'kind',
          ],
          defaultAll: true,
          shouldSort: true,
          distance: 0,
          treshold: 0.0,
          location: 100,
          tokenize: true,
          maxPatternLength: 32,
          minMatchCharLength: 3,
        },
        items: null,
        headers: [
          { text: 'Data Vendita', value: 'posix', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Tipologia', value: 'kind', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Prezzo', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'IVA', value: 'vat', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Utile', value: 'gain', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Pagamento', value: 'payment_method', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Omaggio', value: 'gift', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' },
          { text: 'Punti SH', value: 'points_sh', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' },
          { text: 'Fattura', value: 'invoice', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' },
          { text: 'B2B', value: 'b2b', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' },
          { text: 'Caffè', value: 'coffee', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' },
          { text: 'Utente', value: 'user', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: '', value: 'data-table-expand' },
        ],
      }
    },

    methods: {
      ...mapMutations([
        'SET_FILTRI_STORICO_VENDITE_SEARCH',
      ]),
      posixToItalianDate(posix) {
        return new Date(posix * 1000).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })
      },

      emitFetch() {
        this.$emit('fetch')
      },
      results(results) {
        console.log('e', results)
      },
    },
    computed: {
      ...mapGetters(['getFiltriStoricoVendite']),
      searchFilter: {
        get() {
          return this.getFiltriStoricoVendite.search
        },
        set(value) {
          this.SET_FILTRI_STORICO_VENDITE_SEARCH(value)
        },
      },
    },
    watch: {
      operations: {
        handler(val) {
          this.items = val
        },
        immediate: true,
      },
      search(val) {
        if (!val) {
          this.items = this.operations
          console.log(this.items)
        } else {
          this.$search(val, this.operations, this.options).then((results) => {
            console.log(results)
            this.items = results
          })
        }
      },
    },
  }
</script>

<style></style>
